var map = {
	"./flag_eng.png": 78645,
	"./flag_est.png": 15133,
	"./flag_fin.png": 18010,
	"./flag_lav.png": 56564,
	"./flag_lit.png": 43870,
	"./flag_rus.png": 39391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44199;